<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

interface SheetFooterProps {
  class?: HTMLAttributes['class'];
  bordered?: boolean;
}

const props = withDefaults(defineProps<SheetFooterProps>(), {
  bordered: false,
});
</script>

<template>
  <div data-slot="sheet-footer" :class="cn('mt-auto flex flex-col gap-2 p-4', bordered && 'border-t', props.class)">
    <slot />
  </div>
</template>
